import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>Website created by Eremes</p>
      </div>
    </footer>
  );
};

export default Footer;
